import React from 'react'
import InfoBox from 'components/Shared/InfoBox'
import { useTranslation } from 'react-i18next'

const DestinationUrlCarousel = ({ destinationUrl, isDesktop = false }) => {
  const { t } = useTranslation()

  return (
    <div className={`destination-url-carousel ${isDesktop ? 'desktop' : 'mobile'}`}>
      <span className="destination-url-carousel__url">{destinationUrl}</span>

      <InfoBox 
        body={t('Recommendations.summary.linkNotOnMeta')} 
        classNames="d-inline-block" 
      />
    </div>
  )
}

export default DestinationUrlCarousel